/**
 *  【KYMW1400】コマ情報削除VO
 *
 * @export DeleteKomaModel
 * @class DeleteKomaModel
 */
export class DeleteKomaModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   *  ページID
   */
  public pageID = Number(0);

  /**
   *  ページ番号
   */
  public pageNum = Number(0);

  /**
   *  コマID
   */
  public komaID = Number(0);

  /**
   *  注文商品区分
   */
  public orderGoodsFlg = String('');
}
